import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatSnackBarModule
} from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { ExportDialogComponent } from './export-dialog.component';
import { ExportDialogService } from './services/export-dialog.service';

@NgModule({
  declarations: [
    ExportDialogComponent
  ],
  entryComponents: [
    ExportDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSnackBarModule
  ],
  exports: [
    ExportDialogComponent
  ],
  providers: [
    ExportDialogService
  ]
})
export class ExportDialogModule { }
